import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Paper,
  Tooltip,
} from "@mui/material";
import {
  baseUrl,
  useApplyLinksMutation,
  useFindUserApiQuery,
} from "../../services/apiSlice";
import { green, red, yellow } from "@mui/material/colors";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteModal from "../user-dashboard/CustomerOrBussiness/Delete";
import { ApplyForJob } from "../Apply";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  overflow: "scroll",
  height: "100%",
  p: 4,
};

export const TransitionsModal = ({ singleJob }) => {
  const [applyLinks, { data: dat, error: errors, isError: IsError }] =
    useApplyLinksMutation();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log({ singleJob });

  const { data, error, isError, isSuccess, isFetching } = useFindUserApiQuery();
  const [isApply, setIsApply] = React.useState(false);
  const navigate = useNavigate();
  if (isApply === true) {
    Swal.fire(
      "Update Profile!",
      `  You need to update your profile before you can apply or send quote to customer's. Thanks!!`,
      "info"
    ).then((result) => {
      if (result.isConfirmed || result.isDismissed) {
        navigate(`/dashboard/create-profile`);
      }
    });
  }

  console.log({ data });
  return (
    <>
      <Button
        sx={{
          color: "white",
          px: 4,
          py: 3,
          background: "black",
        }}
        size="small"
        onClick={handleOpen}
      >
        View
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            sx={[
              style,
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "90%",
                  py: 3,
                  mx: 2,
                  px: 3,
                },
              }),
            ]}
          >
            <Card sx={{ width: "100%" }}>
              <CardHeader
                // avatar={
                //   <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                //     R
                //   </Avatar>
                // }
                action={
                  <IconButton aria-label="settings">
                    {/* <MoreVertIcon /> */}
                  </IconButton>
                }
                title={singleJob?.company_name}
                subheader={dayjs(singleJob?.dateCreated).format(
                  "dddd, MMMM D, YYYY h:mm A"
                )}
              />
              {singleJob.files?.map(
                (file, i) => (
                  console.log({ file }),
                  (
                    <CardMedia
                      key={i}
                      component="img"
                      height="140"
                      image={`${baseUrl + `upload/job/` + file?.path}`}
                      sx={{ py: 3 }}
                      alt="green iguana"
                      // src={`${
                      //   baseUrl +
                      //   `upload/` +
                      //   confirmPayment?.confirmPayment?.files?.path
                      // }`}
                    />
                  )
                )
              )}
              {/* <CardMedia
                component="img"
                height="140"
                // image={`${baseUrl + `upload/` + singleJob?.files[0]?.path}`}
                alt="green iguana"
                // src={`${
                //   baseUrl +
                //   `upload/` +
                //   confirmPayment?.confirmPayment?.files?.path
                // }`}
              /> */}
              <CardContent>
                {/* { !isFetching && data?.getUserObject?.subscriptionPlan?.premium === 'premium' && */}

                <>
                  <Typography
                    sx={{
                      color: "black",

                      textTransform: "capitalize",
                    }}
                    gutterBottom
                    variant="h5"
                    component="div"
                  >
                    {singleJob?.categories}
                  </Typography>
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: 16,
                      textTransform: "capitalize",
                    }}
                    variant="body2"
                    color="text.secondary"
                  >
                    {singleJob?.job_description}
                  </Typography>{" "}
                  {!isFetching &&
                    data?.getUserObject?.subscriptionPlan?.type ===
                      "Premium" && (
                      <>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 25,
                            textTransform: "capitalize",
                            textAlign: "center",
                            my: 4,
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          Customer Details
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Email:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {singleJob?.email}
                          </Typography>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Address:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 1,
                            }}
                            variant="span"
                          >
                            {singleJob?.address}
                          </Typography>
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          zip code:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 1,
                            }}
                            variant="span"
                          >
                            {singleJob?.zip_code}
                          </Typography>
                        </Typography>{" "}
                        {singleJob?.company_website !== "" && (
                          <Typography
                            variant="body2"
                            sx={{ py: 2 }}
                            color="text.secondary"
                          >
                            Company website:{" "}
                            <Typography
                              sx={{
                                color: "black",
                                px: 1,
                              }}
                              variant="span"
                            >
                              {singleJob?.company_website}
                            </Typography>
                          </Typography>
                        )}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Mobile Number:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {singleJob?.mobile_number}
                          </Typography>
                        </Typography>
                      </>
                    )}
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Date Posted:{" "}
                    <Typography
                      sx={{
                        color: "black",
                      }}
                      variant="span"
                    >
                      {dayjs(singleJob?.dateCreated).format(
                        "dddd, MMMM D, YYYY h:mm A"
                      )}{" "}
                    </Typography>
                  </Typography>{" "}
                  <Typography variant="body2" color="text.secondary">
                    posted By:
                    <Typography
                      sx={{
                        color: "black",
                        fontSize: 16,
                        textTransform: "capitalize",
                        px: 3,
                      }}
                      variant="span"
                    >
                      {singleJob?.createdBy}
                    </Typography>
                  </Typography>
                </>
              </CardContent>
              <CardActions>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    px: 4,
                    py: 4,
                  }}
                >
                  <Button
                    sx={[
                      {
                        color: "white",
                        px: 4,
                        py: 3,
                        background: green[600],
                      },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          py: 2,

                          px: 2,
                        },
                      }),
                    ]}
                    size="small"
                  >
                    {!isFetching &&
                    data?.getUserObject?.hasProfile === false ? (
                      <Button
                        sx={{ color: "white" }}
                        onClick={() => setIsApply(true)}
                      >
                        Apply{" "}
                      </Button>
                    ) : (
                      <Button
                        sx={{ color: "white" }}
                        onClick={() =>
                          ApplyForJob(
                            singleJob._id,
                            applyLinks,
                            IsError,
                            errors
                          )
                        }
                      >
                        Apply
                      </Button>
                    )}
                  </Button>
                  <Button
                    sx={[
                      {
                        color: "white",
                        px: 4,
                        mx: 4,
                        py: 3,
                        background: red[600],
                      },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          // width: "90%",
                          py: 3,
                          mx: 1,
                          px: 3,
                        },
                      }),
                    ]}
                    onClick={handleClose}
                    size="small"
                  >
                    <CloseIcon />
                  </Button>
                </Box>
              </CardActions>
              {/* <Box
                sx={[
                  {
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "center",
                    // justifyContent: "center",
                    ml: 4,
                    my: 10,
                  },
                  (theme) => ({
                    [theme.breakpoints.down("sm")]: {
                      py: 3,
                      mx: 3,
                      ml: 3,
                    },
                  }),
                ]}
              >
                <Typography
                  variant="p"
                  component="p"
                  className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
                >
                  Upgrade today to have access to customer details and to be
                  able to message them directly
                </Typography>
                <Link to={"/dashboard/premium-plan"}>
                  <Button
                    sx={{
                      background: yellow[600],
                      my: 4,
                      px: 3,
                      py: 2,
                    }}
                    className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full"
                  >
                    Go premium
                  </Button>
                </Link>
              </Box> */}
            </Card>{" "}
            <Paper
              sx={[
                {
                  maxWidth: "lg",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // ml: 10,
                  my: 10,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    py: 3,
                    mx: 3,
                    ml: 3,
                  },
                }),
              ]}
            >
              <Typography
                variant="p"
                component="p"
                sx={{
                  px: 3,
                  py: 4,
                }}
              >
                Upgrade today to have access to customer details and to be able
                to message them directly
              </Typography>
              <Link to={"/dashboard/sub-premium-plan"}>
                <Button
                  sx={{
                    background: yellow[600],
                    my: 4,
                    px: 3,
                    py: 2,
                  }}
                  className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full"
                >
                  Go premium
                </Button>
              </Link>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export const MyJobModal = ({ singleJob }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log({ singleJob });

  const { data, error, isError, isSuccess, isFetching } = useFindUserApiQuery();
  console.log({ data });
  return (
    <>
      <Button
        sx={[
          {
            color: "white",
            px: 4,
            // py: 3,
            background: green[600],
          },
          (theme) => ({
            [theme.breakpoints.down("sm")]: {
              display: "none",
            },
          }),
        ]}
        size="small"
        onClick={handleOpen}
      >
        View
      </Button>

      <Box
        sx={[
          {
            // display: "flex",
            // px: 2,
            // py: 4,
          },
          (theme) => ({
            [theme.breakpoints.up("sm")]: {
              display: "none",
            },
          }),
        ]}
      >
        <Tooltip title="View">
          <IconButton onClick={handleOpen}>
            <MoreVertIcon sx={{ color: yellow[600] }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            sx={[
              style,
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  width: "90%",
                  py: 3,
                  mx: 2,
                  px: 3,
                },
              }),
            ]}
          >
            <Card sx={{ width: "100%" }}>
              <CardHeader
                // avatar={
                //   <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                //     R
                //   </Avatar>
                // }
                action={
                  <IconButton aria-label="settings">
                    {/* <MoreVertIcon /> */}
                  </IconButton>
                }
                title={singleJob?.company_name}
                subheader={dayjs(singleJob?.dateCreated).format(
                  "dddd, MMMM D, YYYY h:mm A"
                )}
              />
              {singleJob.files?.map(
                (file, i) => (
                  console.log({ file }),
                  (
                    <CardMedia
                      key={i}
                      component="img"
                      height="140"
                      image={`${baseUrl + `upload/job/` + file?.path}`}
                      sx={{ py: 3 }}
                      alt="green iguana"
                      // src={`${
                      //   baseUrl +
                      //   `upload/` +
                      //   confirmPayment?.confirmPayment?.files?.path
                      // }`}
                    />
                  )
                )
              )}
              {/* <CardMedia
                component="img"
                height="140"
                // image={`${baseUrl + `upload/` + singleJob?.files[0]?.path}`}
                alt="green iguana"
                // src={`${
                //   baseUrl +
                //   `upload/` +
                //   confirmPayment?.confirmPayment?.files?.path
                // }`}
              /> */}
              <CardContent>
                {/* { !isFetching && data?.getUserObject?.subscriptionPlan?.premium === 'premium' && */}

                <>
                  <Typography
                    sx={{
                      color: "black",

                      textTransform: "capitalize",
                    }}
                    gutterBottom
                    variant="h5"
                    component="div"
                  >
                    {singleJob?.categories}
                  </Typography>
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: 16,
                      textTransform: "capitalize",
                    }}
                    variant="body2"
                    color="text.secondary"
                  >
                    {singleJob?.job_description}
                  </Typography>{" "}
                  {!isFetching &&
                    data?.getUserObject?.subscriptionPlan?.type ===
                      "Premium" && (
                      <>
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 25,
                            textTransform: "capitalize",
                            textAlign: "center",
                            my: 4,
                          }}
                          variant="body2"
                          color="text.secondary"
                        >
                          Customer Details
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Email:
                          <Typography
                            sx={{
                              color: "black",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {singleJob?.email}
                          </Typography>
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Address:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 1,
                            }}
                            variant="span"
                          >
                            {singleJob?.address}
                          </Typography>
                        </Typography>{" "}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          zip code:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 1,
                            }}
                            variant="span"
                          >
                            {singleJob?.zip_code}
                          </Typography>
                        </Typography>{" "}
                        {singleJob?.company_website !== "" && (
                          <Typography
                            variant="body2"
                            sx={{ py: 2 }}
                            color="text.secondary"
                          >
                            Company website:{" "}
                            <Typography
                              sx={{
                                color: "black",
                                px: 1,
                              }}
                              variant="span"
                            >
                              {singleJob?.company_website}
                            </Typography>
                          </Typography>
                        )}
                        <Typography
                          variant="body2"
                          sx={{ py: 2 }}
                          color="text.secondary"
                        >
                          Mobile Number:{" "}
                          <Typography
                            sx={{
                              color: "black",
                              px: 2,
                            }}
                            variant="span"
                          >
                            {singleJob?.mobile_number}
                          </Typography>
                        </Typography>
                      </>
                    )}
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Date Posted:{" "}
                    <Typography
                      sx={{
                        color: "black",
                      }}
                      variant="span"
                    >
                      {dayjs(singleJob?.dateCreated).format(
                        "dddd, MMMM D, YYYY h:mm A"
                      )}{" "}
                    </Typography>
                  </Typography>{" "}
                  <Typography variant="body2" color="text.secondary">
                    posted By:
                    <Typography
                      sx={{
                        color: "black",
                        fontSize: 16,
                        textTransform: "capitalize",
                        px: 3,
                      }}
                      variant="span"
                    >
                      {singleJob?.createdBy}
                    </Typography>
                  </Typography>
                </>
              </CardContent>
              <CardActions>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    px: 4,
                    py: 4,
                  }}
                >
                  {/* <Button
                    sx={{
                      color: "white",
                      px: 4,
                      py: 3,
                      background: green[600],
                    }}
                    size="small"
                  >
                    {!isFetching &&
                    data?.getUserObject?.hasProfile === false ? (
                      <Button onClick={() => setIsApply(true)}>Apply </Button>
                    ) : (
                      <Link to="/dashboard/apply-sucess">Apply</Link>
                    )}
                  </Button> */}{" "}
                  {/* <Tooltip title="Edit Job">
                    <Link to={`/dashboard/edit-job/${singleJob._id}`}>
                      <IconButton sx={{ px: 1 }}>
                        <EditIcon />
                      </IconButton>
                    </Link>
                  </Tooltip> */}
                  <Box
                    sx={{
                      display: "flex",
                      px: 2,
                      py: 4,
                    }}
                  >
                    <Tooltip title="Edit Job">
                      <Link to={`/dashboard/edit-job/${singleJob._id}`}>
                        <IconButton
                          sx={[
                            { px: 3 },
                            (theme) => ({
                              [theme.breakpoints.down("sm")]: {
                                px: 1,
                              },
                            }),
                          ]}
                        >
                          <EditIcon />
                        </IconButton>
                      </Link>
                    </Tooltip>
                    {/* <DeleteModal jobId={singleJob._id} /> */}
                  </Box>
                  {/* <Button
                    onClick={(Delete(singleJob._id), handleClose)}
                    size="small"
                  >
                    <IconButton>
                      <DeleteIcon sx={{ color: red[600] }} />
                    </IconButton>
                  </Button>{" "} */}
                  <Button
                    sx={[
                      {
                        color: "white",
                        px: 4,
                        mx: 4,
                        py: 3,
                        background: "black",
                      },
                      (theme) => ({
                        [theme.breakpoints.down("sm")]: {
                          px: 3,
                          mx: 2,
                        },
                      }),
                    ]}
                    onClick={handleClose}
                    size="small"
                  >
                    Close
                  </Button>
                </Box>
              </CardActions>
              {/* <Box
                sx={[
                  {
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "center",
                    // justifyContent: "center",
                    ml: 4,
                    my: 10,
                  },
                  (theme) => ({
                    [theme.breakpoints.down("sm")]: {
                      py: 3,
                      mx: 3,
                      ml: 3,
                    },
                  }),
                ]}
              >
                <Typography
                  variant="p"
                  component="p"
                  className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
                >
                  Upgrade today to have access to customer details and to be
                  able to message them directly
                </Typography>
                <Link to={"/dashboard/premium-plan"}>
                  <Button
                    sx={{
                      background: yellow[600],
                      my: 4,
                      px: 3,
                      py: 2,
                    }}
                    className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full"
                  >
                    Go premium
                  </Button>
                </Link>
              </Box> */}
            </Card>{" "}
            <Paper
              sx={[
                {
                  maxWidth: "lg",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  // ml: 10,
                  my: 10,
                },
                (theme) => ({
                  [theme.breakpoints.down("sm")]: {
                    py: 3,
                    mx: 3,
                    ml: 3,
                  },
                }),
              ]}
            >
              <Typography
                variant="p"
                component="p"
                sx={{
                  px: 3,
                  py: 4,
                }}
              >
                Upgrade today to have access to customer details and to be able
                to message them directly
              </Typography>
              <Link to={"/dashboard/sub-premium-plan"}>
                <Button
                  sx={{
                    background: yellow[600],
                    my: 4,
                    px: 3,
                    py: 2,
                  }}
                  className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full"
                >
                  Go premium
                </Button>
              </Link>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
